{{display}}@if (!expanded && display.length < value.length) {<button class="icon" (click)="toggle($event)">...</button>}